import { connect } from 'react-redux';

import type { NextOrPreviousPayload } from 'src/components/organisms/ProductMediaCarousel/types';
import type {
  ProductMediaModalDispatchProps,
  ProductMediaModalStateProps,
} from 'src/components/organisms/ProductMediaModal/ProductMediaModal';
import { ProductMediaModal } from 'src/components/organisms/ProductMediaModal/ProductMediaModal';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProductMedia } from 'src/redux/product/selectors';
import { actions } from 'src/redux/productMediaCarousel/slice';
import type { AppThunkDispatch } from 'src/redux/store';

const mapStateToProps = (state: ReduxApplicationState): ProductMediaModalStateProps => {
  return {
    currentMedia: state.productMediaCarousel.currentMedia,
    media: selectProductMedia(state),
    isModalOpen: state.productMediaCarousel.isModalOpen,
  };
};

const mapDispatchToProps = (dispatch: AppThunkDispatch): ProductMediaModalDispatchProps => {
  return {
    closeModal: () => dispatch(actions.closeModal()),
    onNextMedia: (payload: NextOrPreviousPayload) => dispatch(actions.nextMedia(payload)),
    onPrevMedia: (payload: NextOrPreviousPayload) => dispatch(actions.prevMedia(payload)),
  };
};

export const ProductMediaModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProductMediaModal);
